<template>
  <div>
    <navBar></navBar>
    <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
      <van-list
        v-model="loading"
        :finished="finished"
        finished-text="没有更多了"
        @load="onLoad"
      >
        <van-row class="list" v-for="item in eventlist" :key="item.id">
          <van-col span="24" class="list-item" @click="todetail(item)">
            <div class="img">
              <img :src="item.thumb" alt="" />
              <div class="mask">
                {{
                  item.status === "Enrolling"
                    ? "报名中"
                    : item.status === "NotStarted"
                    ? "未开始"
                    : item.status === "Ended"
                    ? "已结束"
                    : "已结束"
                }}
              </div>
            </div>
            <div class="content">
              <p class="title">
                {{ item.title }}
              </p>
              <p class="time">
                活动时间：{{ item.startTime }}
                <span v-if="item.startTime">-</span> {{ item.endTime }}
                <span v-if="!item.startTime">暂未开始</span>
              </p>
            </div>
          </van-col>
        </van-row>
      </van-list>
    </van-pull-refresh>
  </div>
</template>
  <script>
import navBar from "@/components/navBar.vue";
import { Toast } from "vant";
import { myeventlist } from "@/api/home";
export default {
  components: {
    navBar,
  },
  data() {
    return {
      active: 1,
      loading: false,
      finished: false,
      refreshing: false,
      eventlist: [],
      limt: 3,
      page: 1,
      count: 0,
    };
  },
  methods: {
    todetail(item) {
      this.$router.push({
        path: "/activeinfo",
        query: {
          id: item.id,
        },
      });
    },
    onLoad() {
      if (!this.finished) {
        const route = this.$route;
        myeventlist(
          { page: this.page, limit: this.limt, title: this.value },
          route
        )
          .then((res) => {
            this.eventlist.push(...res.list);
            this.count = res.count;
            this.refreshing = false;
            if (this.eventlist.length >= this.count) {
              this.finished = true;
              this.refreshing = false;
              return;
            }
            this.page++;
            // console.log(this.eventlist);

            // Toast("刷新成功");
            this.loading = false;
          })
          .catch((e) => {
            console.log(e.message);
            Toast("加载失败");
            this.loading = false;
            this.refreshing = false;
            this.finished = true;
          });
      }
    },
    onRefresh() {
      this.page = 1;
      this.eventlist = [];
      // 清空列表数据
      this.finished = false;

      // 重新加载数据
      // 将 loading 设置为 true，表示处于加载状态
      // this.loading = true;
      this.onLoad();
    },
    onSearch() {
      // console.log(this.value)
      this.onRefresh();
    },
  },
  created() {
    // this.getlist();
  },
};
</script>
  <style lang="scss" scoped>
.van-list {
  // margin-bottom: 80px;
  margin-top: 46px;
}
.list {
  padding: 15px 18px;
  // border-top: 10px solid #f6f6f6;
  .list-item {
    box-shadow: 1px 0px 7px 0px rgba(0, 0, 0, 0.1);
    border-radius: 4px;
    margin-bottom: 10px;
    .img {
      position: relative;
      img {
        height: 180px;
        width: 100%;
      }
      .mask {
        position: absolute;
        bottom: 6px;
        left: 0;
        width: 100%;
        height: 40px;
        background: rgba(0, 0, 0, 0.3);
        color: #fff;
        font-size: 14px;
        line-height: 40px;
      }
    }
    .content {
      padding: 15px 20px;
      padding-right: 0;
      text-align: left;
      .title {
        font-size: 16px;
        font-weight: bold;
      }
      .time {
        font-size: 14px;

        margin-top: 10px;
      }
    }
  }
  // .list-item:last-child {
  //   margin-bottom: 80px;
  // }
}
.btns {
  width: 100%;
  padding: 0px 18px 20px;
  position: fixed;
  bottom: 0px;
  left: 0;
  z-index: 999;
  box-sizing: border-box;
  // background: #fff;
  .van-button {
    width: 100%;
    background-color: #fff;
    border-color: #2553e2;
    color: #2553e2;
  }
  .active {
    background-color: #2553e2;
    color: #fff;
  }
}
</style>